export enum Tree {
  Status = 'status',
  DisrupterTopic = 'disruptertopic',
  KeyInitiative = 'ki',
  PN = 'pn',
  Function = 'fn',
  GTP = 'gtp',
  ContentType = 'dtyp',
  ContextType = 'dctxt',
  TopicCategory = 'topiccat',
  RolePriority = 'rolepriority',
  Custom = 'custom',
  DemandQuestion = 'demandquestion'
}
